import { ApiError } from '@signalvote/api-client';
import { ErrorCode, isStaleWrite } from '@signalvote/shared';

/** A refused committee-facts save: the field it names (camelCase, as the form keys it), in plain words. */
export interface CommitteeFactError {
  field: string | null;
  message: string;
}

const INVALID: Partial<Record<string, string>> = {
  ein: 'An EIN is 9 digits, like 12-3456789.',
  filingEmail: 'That doesn’t look like an email address.',
  signerEmail: 'That doesn’t look like an email address.',
  committeeFilerId: 'A federal committee ID starts with C.',
};

/** The server names fields as its C# properties do; the form keys them in camelCase. */
const formKey = (field: string) => field.charAt(0).toLowerCase() + field.slice(1);

export function committeeFactError(error: unknown): CommitteeFactError {
  if (!(error instanceof ApiError)) return { field: null, message: 'We couldn’t save that. Try again.' };
  const field = typeof error.body.field === 'string' ? formKey(error.body.field) : null;
  if (isStaleWrite(error)) return { field: null, message: 'These details changed somewhere else. Refresh to see them.' };
  switch (error.code ?? '') {
    case ErrorCode.CommitteeFactRequired:
      return { field, message: 'We need this before you sign.' };
    case ErrorCode.CommitteeFactInvalid:
      return { field, message: (field && INVALID[field]) ?? 'Check this answer.' };
    case ErrorCode.FieldTooLong:
      return { field, message: 'That’s longer than carriers accept. Shorten it.' };
    case ErrorCode.CommitteeFactsLocked:
      return { field: null, message: 'Your details are already with the carriers, so they can’t change now.' };
    default:
      return { field: null, message: 'We couldn’t save that. Try again.' };
  }
}
